import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom'

import classnames from 'classnames'

import Alerts from '../../containers/alerts'
import Login from './../../containers/login'
import Register from './../../containers/register'

import { Logo, LandingFeatures } from './../icons'
import AvoidDave from '../../../assets/img/AvoidDave.jpg'
import VirgoSillamaa from '../../../assets/img/VirgoSillamaa.jpg'

const testimonials = [
  {
    content: `“Ridline is a team with a clear goal in sight, necessary skill sets present and very motivated leadership from day one!”`,
    title: "Music Estonia",
    name: "Virgo Sillamaa",
    img: VirgoSillamaa
  },
  {
    content: `“A beautiful product clearly made by a passionate, experienced team.”`,
    title: "Head of Tallinna Lauluväljak",
    name: "Tim Van Damme",
    img: VirgoSillamaa
  },
  {
    content: `“A beautiful product clearly made by a passionate, experienced team.”`,
    title: "Head of Tallinna Lauluväljak",
    name: "Tim Van Damme",
    img: VirgoSillamaa
  }
]

class Landing extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showLoginModal: false,
      showSignupModal: false,
      email: '',
      bandsPerspective: true,
      activeSlide: 0
    }
  }

  tryItNow = (e) => {
    e.preventDefault()

    this.setState({showSignupModal: true})
  }

  renderLoginModal() {
    const { showLoginModal, email } = this.state

    if (showLoginModal !== true) return null

    return (
      <div className="modal">
        <div className="modal-escape" onClick={() => this.setState({showLoginModal: false})} />

        <div className="modal-content">
          <Login modal={true} />
        </div>
      </div>
    )
  }

  renderSignupModal() {
    const { showSignupModal, email } = this.state

    if (showSignupModal !== true) return null

    return (
      <div className="modal">
        <div className="modal-escape" onClick={() => this.setState({showSignupModal: false})} />

        <div className="modal-content">
          <Register modal={true} email={email} />
        </div>
      </div>
    )
  }

  render() {
    const { email, bandsPerspective, activeSlide } = this.state

    const bandsClassName = classnames({
      'button--inline': true,
      'button--success': bandsPerspective === true,
      'button--primary': bandsPerspective !== true
    })

    const venuesClassName = classnames({
      'button--inline': true,
      'button--success': bandsPerspective !== true,
      'button--primary': bandsPerspective === true
    })

    const featuresSideClassName = classnames({
      'landing-features-side-screen': true,
      'landing-features-side-screen--venue': bandsPerspective !== true,
      'landing-features-side-screen--band': bandsPerspective === true
    })

    return (
      <div className="landing">
        <Alerts />

        {this.renderLoginModal()}
        {this.renderSignupModal()}

        <section className="landing-header">
          <Logo />

          <div className="landing-header-cta">
            <h1 className="heading">Tech riders. <br />Organized.</h1>
            <h3 className="subheading">Manage your riders online. <br/>Designed to bring clarity to every concert.</h3>

            <form onSubmit={this.tryItNow}>
              <input
                type="text"
                className="input--light"
                value={email}
                placeholder="Insert your e-mail address"
                onChange={(e) => this.setState({email: e.target.value})} />
              <button className="button--success focus" type="submit">Try it now</button>
            </form>
          </div>

          <div className="landing-header-featured">
            <Link to="rider/4c8342e6-e1b6-11e8-8bcc-06663252a404/general" target="_blank">
              <img src={AvoidDave} />

              <h3>Avoid Dave joined Ridline</h3>
              <h4>View their rider now</h4>
            </Link>
          </div>

          <div className="landing-header-navigation">
            {/*<button className="button--inline button--link">About</button>*/}
            {/*<button className="button--inline button--link">How do we differ</button>*/}
            <button className="button--inline button--primary" onClick={() => this.setState({showLoginModal: true})}>Log in</button>
          </div>

          <div className="landing-header-features">
            <span>Tech rider online</span>
            <span>Stage plan maker</span>
            <span>Crew collaboration</span>
            <span>Clear overview</span>
            <span>Efficient concert production</span>
          </div>
        </section>

        <section className="landing-features">
          <h2 className="section-title">Features</h2>
          <h3 className="section-subtitle">Features & values</h3>

          <div className="landing-features-side">
            <div className="landing-features-side-navigation">
              <button className={bandsClassName} onClick={() => this.setState({bandsPerspective: true})}>Band’s perspective</button>
              <button className={venuesClassName} onClick={() => this.setState({bandsPerspective: false})}>Organizer’s perspective</button>
            </div>

            {/*<ul>
              <li><a>Add band members</a></li>
              <li><a>Insert requirements</a></li>
              <li><a>Fill the input list</a></li>
              <li><a>Review the output list</a></li>
              <li><a>Create stage plan</a></li>
            </ul>*/}

            {
              bandsPerspective
              ? <ol className="landing-features-list">
                  <li className="landing-features-list-item">
                    <div className="landing-features-list-item-bullet" data-value="•" />

                    <h4>Create your rider</h4>
                    <p>Professional technical requirements <br />communication for every band</p>
                  </li>

                  <li className="landing-features-list-item">
                    <div className="landing-features-list-item-bullet" data-value="•" />

                    <h4>Collaborate and share with ease</h4>
                    <p>Work together with your sound engineer, <br />band members or share information out as a link</p>
                  </li>

                  <li className="landing-features-list-item">
                    <div className="landing-features-list-item-bullet" data-value="•" />

                    <h4>Exchange feedback and be ready for the concert</h4>
                    <p>Once sent to an event, all of the performance agreement <br />changes will are recorded between bands and concert organizers</p>
                  </li>
                </ol>
              : <ol className="landing-features-list">
                  <li className="landing-features-list-item">
                    <div className="landing-features-list-item-bullet" data-value="•" />

                    <h4>Handle riders for your event</h4>
                    <p>Overview of all the performers technical <br />aspects in one place for the whole crew</p>
                  </li>

                  <li className="landing-features-list-item">
                    <div className="landing-features-list-item-bullet" data-value="•" />

                    <h4>Elaborate with bands, order equipment</h4>
                    <p>Agreement changes from all sides are recorded and automatically summarized <br />technical needs are made per event, stage or band -  however you need it</p>
                  </li>

                  <li className="landing-features-list-item">
                    <div className="landing-features-list-item-bullet" data-value="•" />

                    <h4>Be stage ready</h4>
                    <p>For all quality music events - keep things under control, <br />satisfy your performers and audience to the top</p>
                  </li>
                </ol>
            }
          </div>

          <div className={featuresSideClassName} />
        </section>

        <section className="landing-values">
          <h2 className="section-title">Why are we different?</h2>
          <h3 className="section-subtitle">What do we like so much about Ridline?</h3>

          <div className="landing-values-list">
            <div className="landing-values-list-item">
              <h4>Clear overview of <br />all agreements</h4>
              <p>Manage your riders online. Designed to bring clarity to every concert.</p>

              <div className="landing-values-list-item-bullet" />
            </div>

            <div className="landing-values-list-item">
              <h4>Built on experience</h4>
              <p>Manage your riders online. Designed to bring clarity to every concert.</p>

              <div className="landing-values-list-item-bullet" />
            </div>

            <div className="landing-values-list-item">
              <h4>Saves 25 hours on <br />document handling</h4>
              <p>Manage your riders online. Designed to bring clarity to every concert.</p>

              <div className="landing-values-list-item-bullet" />
            </div>

            <div className="landing-values-list-item">
              <h4>Fastest rider creating <br />and processing tool</h4>
              <p>Manage your riders online. Designed to bring clarity to every concert.</p>

              <div className="landing-values-list-item-bullet" />
            </div>
          </div>

          <LandingFeatures />
        </section>

        <section className="landing-testimonials">
          <h2 className="section-title">Others on us</h2>

          <ul className="landing-testimonials-slides">
            <li className="landing-testimonials-slide">
              <div className="landing-testimonials-slide-img" style={{backgroundImage: `url(${testimonials[activeSlide].img})`}} />

              <span className="h1 landing-testimonials-slide-content">{testimonials[activeSlide].content}</span>
              <span className="h4 landing-testimonials-slide-name">{testimonials[activeSlide].name}</span>
              <span className="landing-testimonials-slide-title">{testimonials[activeSlide].title}</span>
            </li>
          </ul>
        </section>

        <section className="landing-footer-cta">
          <h2 className="section-title">Work smarter, not harder</h2>
          <NavLink to={`/register`}>
            <button className="button--block button--success">Start now</button>
          </NavLink>

          <hr />
        </section>

        <section className="landing-footer">
          <span>info@ridline.com</span>
          <span>Veerenni 24, Tallinn, Estonia</span>
          <span>+372 5647 3580</span>
        </section>
      </div>
    )
  }
}

export default Landing



// WEBPACK FOOTER //
// ./src/components/common/landing.js